export var createEventTargetFactory = function createEventTargetFactory(window) {
  return function () {
    if (window === null) {
      throw new Error('A native EventTarget could not be created.');
    }

    return window.document.createElement('p');
  };
};